export let ManagementLevel;

(function (ManagementLevel) {
  ManagementLevel["Owner"] = "owner";
  ManagementLevel["ExecutiveTeam"] = "executive-team";
  ManagementLevel["BoardMember"] = "board-member";
  ManagementLevel["VicePresidentDirector"] = "vice-president-director";
  ManagementLevel["Manager"] = "manager";
  ManagementLevel["StudentIntern"] = "student-intern";
  ManagementLevel["Employee"] = "employee";
  ManagementLevel["Freelancer"] = "freelancer";
})(ManagementLevel || (ManagementLevel = {}));

export const ManagementLevelOptions = Object.values(ManagementLevel);